export default __webpack_public_path__ + "content/dd126cd23626f52c91230a708bd6df77.svg";